import { render, staticRenderFns } from "./ExitPay.vue?vue&type=template&id=ed7e98c6&scoped=true&"
import script from "./ExitPay.vue?vue&type=script&lang=js&"
export * from "./ExitPay.vue?vue&type=script&lang=js&"
import style0 from "./ExitPay.vue?vue&type=style&index=0&id=ed7e98c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7e98c6",
  null
  
)

export default component.exports